import React from 'react';
import styled, { keyframes } from 'styled-components';
import IconTickCircle from 'icons/IconTickCircle';

const fadeOut = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Block = styled.div`
  margin-top: 20px;
  font-size: 24px;
  color: #000000;
  text-align: center;
  opacity: 0;
  animation: ${fadeOut} 0.4s linear;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;

  @media (min-width: 1000px) {
    font-size: 30px;
  }
`;

const Icon = styled.div`
  font-size: 48px;
`;

const Result = () => (
  <Block>
    <Icon>
      <IconTickCircle />
    </Icon>
    <div>
      Ура! Осталось активировать учетную запись из&nbsp;письма на&nbsp;вашей
      электронной почте.
    </div>
  </Block>
);

export default Result;
